import React, { useState, useEffect } from "react";
import { useIntl, defineMessages } from "react-intl";

interface TimerProps {
  createdAt: string; // Data de criação no formato ISO
  expiresAt: string; // Data de expiração no formato ISO
}

const messages = defineMessages({
  expired: { id: "software.employee.expired" },
});

const Timer: React.FC<TimerProps> = ({ createdAt, expiresAt }) => {
  const { formatMessage } = useIntl();
  const [timeRemaining, setTimeRemaining] = useState<number>(0); // Inicializa com 0

  const timer = React.useCallback(async () => {
    // Atualiza o timer imediatamente ao montar o componente
    updateTimer();

    const interval = setInterval(() => {
      updateTimer();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    timer();
  }, [timer]);

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  const updateTimer = (): void => {
    const expiresAtDate = new Date(expiresAt);
    const now = new Date();

    // Verifica se a data atual ultrapassou a data de expiração
    if (now >= expiresAtDate) {
      setTimeRemaining(0);
    } else {
      // Calcula os segundos restantes
      const secondsRemaining = Math.max(
        0,
        Math.floor((expiresAtDate.getTime() - now.getTime()) / 1000)
      );
      setTimeRemaining(secondsRemaining);
    }
  };

  return (
    <div>
      {timeRemaining === 0 ? (
        <>{formatMessage(messages.expired)}</>
      ) : (
        <span>{formatTime(timeRemaining)}</span>
      )}
    </div>
  );
};

export default Timer;
